import { path } from 'ramda';
import { SET_APP_FILTER } from '../../../constants/filter';
import { DEFAULT_CATEGORY } from '../../../constants/categories';

export const initialState = {
  category: DEFAULT_CATEGORY,
};

const filter = (state = initialState, { type, payload }) => {
  return type === SET_APP_FILTER ? { ...state, ...payload } : state;
};

export default filter;
/**
 * SELECTORS
 */
export const appFilterSelector = (state) => path(['app', 'filter'], state);
export const appFilterCategorySelector = (state) =>
  path(['app', 'filter', 'category'], state);
